// service.js文件
import axios from 'axios'
import config from './config.js'
import router from '../router'
import Vue from 'vue'
import store from '../store'

import { getCurrentInstance } from 'vue';

let ajaxUrl = config.apiUrl
let loading

axios.ajax = (option, proxy) => {
    if (option.showLoading) {
        loading = Vue.prototype.$loading({
            lock: false,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.3)'
        });
    }
    if (!option) {
        console.error("util.ajax cannot do without option");
        return false;
    }
    if (!option.params) {
        option.params = {};
    }
    var url = option.prefix ? option.prefix + option.url : ajaxUrl + option.url;
    // var extendParams = {
    //     params: {}
    // };

    //如果需要token且没有传入token,尝试从window._vue中取token
    //    if(option.controllFlag!=="NC" && !option.token && window._vue){
    //    	option.token=window._vue.$store.state.app.loginToken;
    //    }
    // if(window._vue && window._vue.$route.meta && window._vue.$route.meta.id){
    // 	extendParams.params.moduleId = window._vue.$route.meta.id;
    // 	extendParams.params.moduleName = window._vue.$route.meta.title;
    // }
    var headersStr = null;
    if (localStorage.getItem('token')) {
        headersStr = 'Bearer ' + localStorage.getItem('token');
    }

    let createObj = {
        baseURL: url,
        timeout: option.timeout || 200000,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': headersStr
        }
    }
    if (option.responseType) {
        createObj.responseType = option.responseType;
    }
    var ccssoftAjax = axios.create(createObj);
    //添加缓存机制,cache的参数为毫秒,会将ajax的结果保存一定时间

    if (option.type === "get") {
        ccssoftAjax.get(option.functionId, option.params).then((res) => {
            loading && loading.close();
            if (option.success && typeof option.success === 'function') {
                option.success(res.data);
            }
        }).catch(err => {
            loading && loading.close();
            if (err && err.response) {
                if (err.response.status === 401 || err.response.status === 500) {
                    localStorage.removeItem('userinfo')
                    localStorage.removeItem('token')
                    Vue.prototype.$Message.info('请先登录查看');
                    localStorage.setItem('lastVisitPath', proxy ? proxy.$route.fullPath : '/');
                    store.commit('setPath', proxy ? proxy.$route.fullPath : '/')
                    setTimeout(() => {
                        router.push({
                            path: "/login",
                        });
                    }, 1800)
                }
            }
            if (option.error && typeof option.error === 'function') {
                option.error(err);
            }

        });
    } else {
        ccssoftAjax.post(option.functionId, option.params).then((res) => {
            loading && loading.close();
            if (option.responseType === "blob") {
                // util.download(res.data, option.fileName);
            } else {
                if (option.success && typeof option.success === 'function') {
                    option.success(res.data);
                }
            }
        }).catch(err => {
            loading && loading.close();
            if (err && err.response) {
                if (err.response.status === 401 || err.response.status === 500) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('userinfo')
                    Vue.prototype.$Message.info('请先登录查看');
                    store.commit('setPath', proxy ? proxy.$route.fullPath : '/')
                    localStorage.setItem('lastVisitPath', proxy ? proxy.$route.fullPath : '/');
                    setTimeout(() => {
                        router.push({
                            path: "/login",
                        });
                    }, 1800)
                }
            }
            if (option.error && typeof option.error === 'function') {
                option.error(err);
            }
        });
    }
}

axios.post = function(option) {
    if (option) {
        option.type = "post";
        let proxy = getCurrentInstance() && getCurrentInstance().proxy ? getCurrentInstance().proxy : null
        axios.ajax(option, proxy);
    } else {
        console.error("util.post cannot do without option");
    }
}

axios.get = function(option) {
    if (option) {
        option.type = "get";
        let proxy = getCurrentInstance() && getCurrentInstance().proxy ? getCurrentInstance().proxy : null
        axios.ajax(option, proxy);
    } else {
        console.error("util.post cannot do without option");
    }
}

export default axios